<template>
  <div :class="[bem(), isLowAndroid ? 'low-android' : '']">
    <nx-empty :type="type" :image="image" :isFullScreen="false" :description="description" :buttonText="buttonText">
      <slot name="default"></slot>
    </nx-empty>
  </div>
</template>

<script>
import { create } from '../utils'
import { Empty } from '@vivo/vos-ui'
import env from '@/utils/clientEnv'
export default create({
  name: 'empty',
  components: {
    [Empty.name]: Empty
  },
  data() {
    return {
      isLowAndroid: env.androidLevel && env.androidLevel < 8 && this.isLowAndroidStyle && env.isVivoApp
    }
  },
  props: {
    type: {
      type: String,
      default: 'content'
    },
    image: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    // 目前发现部分页面原有嵌套样式在低版本安卓上有问题，需要单独添加margin-top适配
    // todo: 是否有更好方法
    isLowAndroidStyle: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
.v-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  &.low-android {
    margin-top: 800px;
  }
}
::v-deep {
  .nx-empty__wrap,
  .nx-empty__wrap__non-full {
    // position: inherit;
    .btn-group .nx-button {
      color: $brand !important;
      border: 9px solid $brand !important;
    }
  }
}
</style>
